import axios from "axios";

export const getRoots = async (token) => {
  const apiUrl = `${process.env.REACT_APP_SERVER_URL}/roots`;
  try {
    const response = await axios.get(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching Sanskrit roots:", error);
    throw error;
  }
};
